var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSafeIcon = function SvgSafeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#EAB308",
    fillRule: "evenodd",
    d: "M10.889 4.444h18.889a6.116 6.116 0 0 1 6.11 6.112v18.889a6.12 6.12 0 0 1-4.443 5.88v1.897a1.667 1.667 0 0 1-3.334 0v-1.666H12.556v1.666a1.667 1.667 0 0 1-3.334 0v-1.897a6.12 6.12 0 0 1-4.444-5.88v-.556h-.556a1.667 1.667 0 0 1 0-3.333h.556v-3.89h-.556a1.667 1.667 0 0 1 0-3.333h.556v-3.888h-.556a1.667 1.667 0 0 1 0-3.334h.556v-.555a6.116 6.116 0 0 1 6.11-6.112M22 25.556V21.89a4.44 4.44 0 0 0 2.778-4.113 4.45 4.45 0 0 0-4.445-4.445 4.45 4.45 0 0 0-4.444 4.445 4.44 4.44 0 0 0 2.778 4.113v3.665a1.667 1.667 0 0 0 3.333 0",
    clipRule: "evenodd"
  })));
};
export default SvgSafeIcon;